import SecuritySettings from "./SecuritySettings";
export default SecuritySettings;
